import React from 'react'

function ProcessBig() {
  return (
    <svg
      width={96}
      height={85}
      viewBox="0 0 96 85"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity={0.32}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M30.386 53.605L20.788 68H0v12h21.86a10 10 0 008.32-4.453l7.417-11.125-7.212-10.816zm12.018-18.027l7.417-11.125A10 10 0 0158.14 20h17.86L76 32H59.212l-9.597 14.394-7.211-10.816z"
          fill="#fff"
        />
        <path d="M76 40V12l20 14-20 14z" fill="#fff" />
        <path
          d="M0 26h21.86a4 4 0 013.328 1.781L54.813 72.22A4 4 0 0058.14 74H76"
          stroke="#fff"
          strokeWidth={12}
        />
        <path d="M76 60v28l20-14-20-14z" fill="#fff" />
      </g>
    </svg>
  )
}

export default React.memo(ProcessBig)
